import Pg2Row from './Pg2Row.jsx';

/** Property grid row: full Pg2Row, or compact flex row for primitive array items */
export function wrapPropertyGridRow(ctx, labelSlot, defaultSlot) {
    if (ctx.arrayItemInline && ctx.propertygrid) {
        return (
            <div class="c-PropertyGrid2__arrayItemRow c-PropertyGrid2__arrayItemRow--field">
                <div class="c-PropertyGrid2__arrayItemRow__label">{labelSlot()}</div>
                <div class="c-PropertyGrid2__arrayItemRow__control property-grid">{defaultSlot()}</div>
            </div>
        );
    }
    return (
        <Pg2Row>
            {{
                label: labelSlot,
                default: defaultSlot,
            }}
        </Pg2Row>
    );
}
